import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Returns `true` while the backend is still on the Viva demo/sandbox
 * environment (`VIVA_ENVIRONMENT="demo"`), `false` once it's flipped to
 * `"production"`.
 *
 * Any UI that must NEVER render against real customer money — the QR
 * scanner's "Demo: Scan Guest Pass" button, the "Closed Beta — no real
 * charges" banner, seed shortcuts, test-card hints — should gate itself
 * on this hook. That way there's zero risk of a stale build showing demo
 * chrome after the ops flip to live.
 */
export function useIsDemoEnv() {
  const [isDemoEnv, setIsDemoEnv] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/config/runtime`)
      .then((res) => setIsDemoEnv(res.data?.payment_environment === 'demo'))
      .catch(() => setIsDemoEnv(false));
  }, []);

  return isDemoEnv;
}
